['enquiry-popup', 'partner-popup', 'hll-global-popup','parivartan-enquiry','hll-global-enquiry'].forEach(function (id) {
  document.querySelectorAll('[data-popup="' + id + '"]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var popup = document.getElementById(id);
      if (popup) popup.hidden = false;
    });
  });
});